import { defineStore } from 'pinia'
import { useApi } from '@/utils/axios'
import { PERFIL_ROTAS } from '@/utils/apiRoutes'

export const usePerfilUsuarioStore = defineStore('perfilUsuario', {
  state: () => ({
    perfis: [],
    paginas: [],
    loading: false,
    error: null,
    meta: {
      current_page: 1,
      total: 0,
      per_page: 100,
      last_page: 1,
    },
  }),
  actions: {
    async fetchPerfis() {
      this.loading = true
      try {
        const api = useApi(PERFIL_ROTAS.PERFIS_USUARIO)
        const response = await api.fetch()
        this.perfis = response.data
      } catch (error) {
        this.error = 'Erro ao buscar perfis'
      } finally {
        this.loading = false
      }
    },
    async fetchPerfilById(id) {
      this.loading = true
      try {
        const api = useApi(PERFIL_ROTAS.PERFIS_USUARIO)
        const response = await api.fetch({ id })
        return response.data
      } catch (error) {
        this.error = 'Erro ao buscar perfil'
        return null
      } finally {
        this.loading = false
      }
    },
    async fetchPaginas(id, { page = 1, perPage = 10 } = {}) {
      this.loading = true
      try {
        const permissoesApi = useApi(PERFIL_ROTAS.PERMISSOES)
        const response = await permissoesApi.fetch({
          id: PERFIL_ROTAS.PAGINAS_PERFIL(id),
          params: { page, per_page: perPage },
        })
        this.paginas = response.data
        this.meta = response.meta
      } catch (error) {
        this.error = 'Erro ao buscar páginas'
      } finally {
        this.loading = false
      }
    },
    async createPerfil(perfil) {
      this.loading = true
      try {
        const api = useApi(PERFIL_ROTAS.PERFIS_USUARIO)
        await api.post(perfil)
        await this.fetchPerfis()
      } catch (error) {
        this.error = 'Erro ao criar perfil'
      } finally {
        this.loading = false
      }
    },
    async updatePerfil(perfil) {
      this.loading = true
      try {
        const api = useApi(PERFIL_ROTAS.PERFIS_USUARIO)
        await api.put(perfil, perfil.id)
        await this.fetchPerfis()
      } catch (error) {
        this.error = 'Erro ao atualizar perfil'
      } finally {
        this.loading = false
      }
    },
    async deletePerfil(id) {
      this.loading = true
      try {
        const api = useApi(PERFIL_ROTAS.PERFIS_USUARIO)
        await api.del(id)
        await this.fetchPerfis()
      } catch (error) {
        this.error = 'Erro ao deletar perfil'
      } finally {
        this.loading = false
      }
    },
    async updatePaginaEstado(perfilId, paginaId, estado) {
      this.loading = true
      try {
        const permissoesApi = useApi(PERFIL_ROTAS.PERMISSOES)
        if (estado === 0) {
          await permissoesApi.del(PERFIL_ROTAS.PAGINAS_PERFIL(perfilId), {
            paginas_ids: [paginaId],
          })
        } else {
          await permissoesApi.postWithId(PERFIL_ROTAS.PAGINAS_PERFIL(perfilId), {
            paginas_ids: [paginaId],
          })
        }
      } catch (error) {
        this.error = 'Erro ao atualizar estado da página'
      } finally {
        this.loading = false
      }
    },
  },
})
